import { render, staticRenderFns } from "./projectsMap.vue?vue&type=template&id=0acce2c2&scoped=true"
import script from "./projectsMap.vue?vue&type=script&lang=js"
export * from "./projectsMap.vue?vue&type=script&lang=js"
import style0 from "./projectsMap.vue?vue&type=style&index=0&id=0acce2c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acce2c2",
  null
  
)

export default component.exports